import React, { useEffect, useState } from "react";
import { Row, Carousel, Button, Container, Tab, Nav } from "react-bootstrap";
import "./PopupNotification/popup.css";
import TransferPriceTab from "./PopupNotification/TransferPriceTab";
import ApprovalTab from "./PopupNotification/ApprovalTab";
import VerifyWeightTab from "./PopupNotification/VerifyWeightTab";
import api from '../../seller-apis/api';
import moment from "moment";
import { fetchAllNotifications } from '../../seller-apis/apidataField';
import { Actions } from "../../Actions/Actions";
import { useDispatch, useSelector } from "react-redux";
function PopupNotification(props) {
  
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("transferPrice");
  const [counts, setCounts] = useState({
    transferPrice: 0,
    approval: 0,
    verifyWeight: 0
  });
  const [refreshTrigger, setRefreshTrigger] = useState({
    transferPrice: 0,
    approval: 0,
    verifyWeight: 0
  });

  var dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
  var dateToWeb = moment().format('YYYY-MM-DD');

  useEffect(() => {
  refreshGlobalCount();
}, []);
  const handleCountUpdate = (tab, count) => {
    setCounts(prev => ({ ...prev, [tab]: count }));
  };

  // ✅ Trigger refresh when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Trigger refresh for the selected tab
    setRefreshTrigger(prev => ({
      ...prev,
      [tab]: prev[tab] + 1
    }));
  };

  // ✅ FIXED: Refresh ALL tabs AND reset ALL counts when notification is closed
  const handleNotificationClosed = (sourceTab) => {
    console.log(`Notification closed in ${sourceTab}, refreshing ALL tabs and resetting all counts`);
    
    // ✅ STEP 1: Reset ALL counts to 0
    setCounts({
      transferPrice: 0,
      approval: 0,
      verifyWeight: 0
    });
    
    // ✅ STEP 2: Refresh ALL tabs (including source tab to get fresh data)
    setRefreshTrigger(prev => ({
      transferPrice: prev.transferPrice + 1,
      approval: prev.approval + 1,
      verifyWeight: prev.verifyWeight + 1,
    }));
  };

  const refreshGlobalCount = () => {
  const countData = {
    pageNo: 1, size: 1,
    filters: {
      type: { $in: ["PRC_CHANGED"] },
      opened: false,
      "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
      "to-createdAt": dateToWeb + 'T23:59:59.000Z'
    },
  };
  api.notify.fetchNotifications(fetchAllNotifications(countData))
    .then(res => Actions.updateNotificationCount(dispatch, res.totalRecords))
    .catch(err => console.log(err));
};

const closePopup = () => {
  props.popupVisibility()
}

  return (
    <>
      <div className="pn-wrapper-v2">
        <div className="pn-container">
          <div className="pn-header">
            <h2 className="pn-title">Notification</h2>
            <a className="pn-close-btn" onClick={() => props.popupVisibility()}>
              &times;
            </a>
          </div>
          
          <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            <Nav variant="tabs" className="pn-tabs-container">
              <Nav.Item>
                <Nav.Link eventKey="transferPrice">
                  Transfer Price
                  {counts.transferPrice > 0 && (
                    <span className="pn-tab-badge">{counts.transferPrice}</span>
                  )}
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link eventKey="approval">
                  New Products
                  {counts.approval > 0 && (
                    <span className="pn-tab-badge">{counts.approval}</span>
                  )}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="verifyWeight">
                  Verify Weight
                  {counts.verifyWeight > 0 && (
                    <span className="pn-tab-badge">{counts.verifyWeight}</span>
                  )}
                </Nav.Link>
              </Nav.Item> */}
            </Nav>

            <div className="pn-content-area">
              <Container fluid>
                <Tab.Content>
                  <Tab.Pane eventKey="transferPrice">
                    <TransferPriceTab 
                      onCountUpdate={(count) => handleCountUpdate("transferPrice", count)} 
                      refreshTrigger={refreshTrigger.transferPrice}
                      onNotificationClosed={() => handleNotificationClosed('transferPrice')}
                      refreshGlobalCount={refreshGlobalCount}
                      onClose={closePopup}
                    />
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey="approval">
                    <ApprovalTab 
                      onCountUpdate={(count) => handleCountUpdate("approval", count)} 
                      refreshTrigger={refreshTrigger.approval}
                      onNotificationClosed={() => handleNotificationClosed('approval')}
                      refreshGlobalCount={refreshGlobalCount}
                    />
                  </Tab.Pane> */}
                  {/* <Tab.Pane eventKey="verifyWeight">
                    <VerifyWeightTab 
                      onCountUpdate={(count) => handleCountUpdate("verifyWeight", count)} 
                      refreshTrigger={refreshTrigger.verifyWeight}
                      onNotificationClosed={() => handleNotificationClosed('verifyWeight')}
                      refreshGlobalCount={refreshGlobalCount}
                    />
                  </Tab.Pane> */}
                </Tab.Content>
              </Container>
            </div>
          </Tab.Container>
        </div>
      </div>
    </>
  );
}

export default PopupNotification;